import { Button } from '@app/components/ui/button';
import SplitButton from '@cloud-ui/components/ui/SplitButton';
import { ROUTES } from '@cloud-ui/constants';

import { FileText, Plus, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

type NewScanOrEvalButtonProps = {
  canCreateJobs: boolean;
  evalCreatorEnabled: boolean;
  isRedTeamEnabled: boolean;
};

export default function NewScanOrEvalButton({
  canCreateJobs,
  evalCreatorEnabled,
  isRedTeamEnabled,
}: NewScanOrEvalButtonProps) {
  const navigate = useNavigate();
  const canRunRedTeam = isRedTeamEnabled && canCreateJobs;

  const startIcon = <Plus className="size-4" />;

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  if (!canRunRedTeam && !evalCreatorEnabled) {
    return null;
  }

  if (canRunRedTeam && evalCreatorEnabled) {
    return (
      <SplitButton
        data-testid="new-scan-or-eval-button"
        label={<span className="sr-only sm:not-sr-only">New</span>}
        startIcon={startIcon}
        compactOnMobile
        options={[
          {
            label: 'New Red Team',
            icon: <Shield className="size-4" data-testid="new-red-team-icon" />,
            onClick: () => handleNavigation(ROUTES.redteam.createScan),
          },
          {
            label: 'New Eval',
            icon: <FileText className="size-4" data-testid="new-eval-icon" />,
            onClick: () => handleNavigation(ROUTES.evalCreate),
          },
        ]}
      />
    );
  }

  if (canRunRedTeam) {
    return (
      <Button
        type="button"
        onClick={() => handleNavigation(ROUTES.redteam.createScan)}
        data-testid="new-scan-or-eval-button"
        className="w-9 px-0 sm:w-auto sm:px-4"
      >
        {startIcon}
        <span className="sr-only sm:not-sr-only">New Scan</span>
      </Button>
    );
  }

  return (
    <Button
      type="button"
      onClick={() => handleNavigation(ROUTES.evalCreate)}
      data-testid="new-scan-or-eval-button"
      className="w-9 px-0 sm:w-auto sm:px-4"
    >
      {startIcon}
      <span className="sr-only sm:not-sr-only">New Eval</span>
    </Button>
  );
}
